import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import "./component.css";
import axiosNew from "../store/api/axiosNew";
import { useNavigate } from "react-router-dom";

const categoryOptions = [
  { value: 1, label: "Apartments" },
  { value: 2, label: "Plots" },
  { value: 3, label: "Villas" },
];
const countryOptions = [
  { label: "India", value: "2" },
]

export default function UpdateUserModal({ show, handleClose, onSuccess }) {
  const navigate = useNavigate();
  const [address, setAddress] = useState("");
  const [jobsPerDay, setJobsPerDay] = useState("");
  const [teamStrength, setTeamStrength] = useState("");
  const [category, setCategory] = useState(null);
  const [myCountry, setCountry] = useState(null);
  const [state, setState] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const [user, setUser] = useState(null);

  useEffect(() => {
    if (show) {
      const u = {
        name: localStorage.getItem("name"),
        email: localStorage.getItem("email"),
        mobileNo: localStorage.getItem("phone"),
      };
      setUser(u);
    }
  }, [show]);

  useEffect(() => {
    const storedCountry = sessionStorage.getItem("selectedSubService");
    if (storedCountry) {
      const foundCountry = countryOptions.find((c) => c.label === storedCountry);
      if (foundCountry) {
        setCountry(foundCountry);
        fetchStates(foundCountry.value);
      }
    }
  }, []);

  const fetchStates = async (countryId) => {
    try {
      const response = await fetch(`https://stageapilead.blaccdot.com/ldsstage/masters/location/country-based-province/${countryId}`);
      const data = await response.json();
      if (data?.data?.locationmaster) {
        const formattedStates = data.data.locationmaster.map((s) => ({
          label: s.locationName,
          value: s.provinceId,
        }))
        setStateOptions(formattedStates);
      }
    }
    catch (err) {
      console.error("Error fetching states:", err);
      setStateOptions([]);
    }
  };

  // useEffect(() => {
  //     if (user) {
  //         setAddress(user.address || "")
  //         setJobsPerDay(user.jobsPerDay || "")
  //         setTeamStrength(user.teamStrength)
  //         if (user.category && user.categoryName) {
  //             setCategory({
  //                 value: user.category,
  //                 label: user.categoryName,
  //             })
  //         }
  //     }
  // }, [user])

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      address,
      jobsPerDay,
      teamStrength,
      category: category?.value,
      categoryName: category?.label,
      country: myCountry?.label || "",
      state: state.map((s) => s.value).join(","),
    };
    console.log("Update profile payload:", payload);
    try {
      const userId = localStorage.getItem("id");
      const res = await axiosNew.put(`/auth/user/${userId}`, payload);
      if (res.data.success) {
        onSuccess?.();
        console.log("success hay");
        navigate("/upgrade-plan");
        // setTimeout(() => {
        //   console.log("success in");
        //   handleClose();
        //   console.log("success out");
        // }, 3000);
      }
    } catch (err) {
      console.error("Error updating profile:", err);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      contentClassName="verify-modal-content"
    >
      <div className="verify-modal-body">
        <h5 className="title">Complete Your Profile</h5>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" value={user?.name || ""} readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" value={user?.email || ""} readOnly />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  value={user?.mobileNo || ""}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Jobs Per Day</Form.Label>
                <Form.Control
                  type="number"
                  value={jobsPerDay}
                  onChange={(e) => setJobsPerDay(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Team Strength</Form.Label>
                <Form.Control
                  type="number"
                  value={teamStrength}
                  onChange={(e) => setTeamStrength(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Country</Form.Label>
                <Select options={countryOptions} value={myCountry} onChange={(opt) => {
                  setCountry(opt);
                  setState([]);
                  fetchStates(opt.value);
                }}
                  placeholder="--Select Country--" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>State</Form.Label>
                <Select isMulti options={stateOptions} value={state} onChange={setState} isDisabled={!myCountry} placeholder="--Select State--" />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Category</Form.Label>
                <Select
                  options={categoryOptions}
                  value={category}
                  onChange={setCategory}
                  placeholder="Select Category"
                />
              </Form.Group>
            </Col>
            <Col md={6}></Col>
          </Row>

          <div className="d-flex justify-content-center mt-3">
            <Button type="submit" variant="primary" style={{ width: "80%" }}>
              Save Profile
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
